import {
	Bar,
	CartesianGrid,
	ComposedChart,
	Legend,
	Line,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import type { MeasurementHistoryResponse } from "@/adapters/api";
import { formatCount, formatPoints } from "../../utils/format.ts";
import { Chart } from "../chart/index.tsx";

export interface MeasurementHistoryProps {
	data?: MeasurementHistoryResponse;
	isPending: boolean;
	isError: boolean;
}

export function MeasurementHistory({
	data,
	isPending,
	isError,
}: MeasurementHistoryProps) {
	const periods = data?.periods ?? [];
	const hasData = periods.some(
		(period) => period.count > 0 || period.gain_points > 0,
	);

	return (
		<Chart
			label="Medições registradas e avanço obtido por período"
			height={240}
			isPending={isPending}
			isError={isError}
			isEmpty={!hasData}
			emptyMessage="Nenhuma medição registrada no período."
			table={{
				columns: ["Período", "Medições", "Avanço"],
				rows: periods.map((period) => [
					period.label,
					formatCount(period.count),
					formatPoints(period.gain_points),
				]),
			}}
		>
			<ComposedChart
				data={periods}
				margin={{ top: 8, right: 8, bottom: 0, left: 0 }}
			>
				<CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
				<XAxis dataKey="label" tickLine={false} axisLine={false} />
				<YAxis
					yAxisId="count"
					allowDecimals={false}
					tickLine={false}
					axisLine={false}
				/>
				<YAxis
					yAxisId="gain"
					orientation="right"
					tickLine={false}
					axisLine={false}
				/>
				<Tooltip
					formatter={(value, name) =>
						name === "Avanço"
							? formatPoints(Number(value))
							: formatCount(Number(value))
					}
				/>
				<Legend />
				<Bar
					yAxisId="count"
					dataKey="count"
					name="Medições"
					fill="var(--chart-2)"
					radius={[4, 4, 0, 0]}
				/>
				<Line
					yAxisId="gain"
					type="monotone"
					dataKey="gain_points"
					name="Avanço"
					stroke="var(--chart-1)"
					strokeWidth={2}
					dot={{ r: 3 }}
				/>
			</ComposedChart>
		</Chart>
	);
}
